type TRotatingIndexCreationFn = (maximumIndex: number) => { getIndex: () => number; rotateIndex: () => void };

const createRotatingIndex: TRotatingIndexCreationFn = (maximumIndex) => {
  if (maximumIndex === 0) {
    return { getIndex: () => 0, rotateIndex: () => {} };
  }

  let privateIndex = 0;

  const getIndex = () => privateIndex;
  const rotateIndex = () => {
    if (privateIndex + 1 > maximumIndex) {
      privateIndex = 0;
      return;
    }
    privateIndex += 1;
  };

  return {
    getIndex,
    rotateIndex,
  };
};

export default createRotatingIndex;
